import { Component, OnInit } from '@angular/core';

import { MenuItem } from 'primeng/api';
import { VirtualScrollerModule } from 'primeng/virtualscroller';

import { Router } from '@angular/router';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { FacesService } from '../faces.service';
import { AuthService } from '../auth.service';

import { Photo } from '../photo'

@Component({
  selector: 'app-facegate-photos',
  templateUrl: './facegate-photos.component.html',
  styleUrls: ['./facegate-photos.component.css']
})
export class FacegatePhotosComponent implements OnInit {

  public items: MenuItem[];
  private data: any = null;
  public employees: Photo[] = [];

  constructor(
    private router: Router,
    private http: HttpClient,
    private faces: FacesService,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.loadFaces();
    this.loadServicesMenu();
  }

  onClickDelete(index) {

    this.auth.getCurrentSession().subscribe(
      currSess => {
        console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        //console.log("IdToken = " + idToken);
        let username = currSess.accessToken.payload.username;
        this.faces.deleteFace(idToken,username,this.employees[index].type_key).subscribe(
          data => {
            if(data.result == "OK") {
              alert("delete OK:  eliminato user con type_key " + this.employees[index].type_key);
            }
          },
          error => {
            alert("DELETE ERROR");
            console.log("Failed getAppsSW2: error = " + JSON.stringify(error, null, 2))
          }
        );
      },
      error => {
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }
    );
    this.loadFaces();
  } // end onClickDelete

  loadFaces(){

    this.auth.getCurrentSession().subscribe(

      currSess => {
        //console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        //console.log("IdToken = " + idToken);
        let username = currSess.accessToken.payload.username;
        this.faces.readAllFaces(idToken, username).then(
          employees =>  {
            this.employees = employees;

            function compare(a,b) {
              if (a.cognome < b.cognome)
                return -1;
              if (a.cognome > b.cognome)
                return 1;
              return 0;
            }
            this.employees.sort(compare);
          }
      );
      },
      /*error => {
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }*/
    );
  } // end loadFaces


  loadServicesMenu() {
    this.items = [
      {
        label: 'DATI',
        items: [
          {label: 'I miei dati', icon: 'pi pi-fw pi-file', routerLink: ['/home']},
          {label: 'La mia sottoscrizione', icon: 'pi pi-fw pi-dollar', routerLink: ['/payFacegate']}
        ]
      },
      {
        label: 'SERVIZI',
        items: [
          {label: 'Registro foto', icon: 'pi pi-fw pi-camera'},
          {label: 'Dati riepilogativi', icon: 'pi pi-fw pi-users', routerLink: ['/reportsFacegate']},
          //{label: 'Configurazione', icon: 'pi pi-fw pi-cog', routerLink: ['/reportConfig']}
        ]
      }
    ];
  } // end loadServicesMenu
}
